"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertlisteners = exports.getDisplayName = void 0;

var getDisplayName = function getDisplayName(WrappedComponent) {
  var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return "callListenerProvider(".concat(wrappedComponentName, ")");
};

exports.getDisplayName = getDisplayName;

var assertlisteners = function assertlisteners() {
  var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return listeners.filter(function (listener) {
    return typeof listener === 'function';
  });
};

exports.assertlisteners = assertlisteners;